import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="center-state">
      <h1>404</h1>
      <p>{t('common.empty')}</p>
      <Link to="/" className="btn btn-primary">
        {t('common.back')}
      </Link>
    </div>
  );
}
